import { HoukatsuStatus, KYCStatus } from 'apollo/queries/autogenerate/schemas';

/**
 *  Return true only for Houkatsu approved consumers (eKYC and Houkatsu approved)
 * @param kycStatus user eKYC status
 * @param houkatsuStatus user houkatsu status
 */
export const isPlusUser = (
  kycStatus?: KYCStatus,
  houkatsuStatus?: HoukatsuStatus
) => {
  return (
    kycStatus === KYCStatus.APPROVED &&
    (houkatsuStatus === HoukatsuStatus.APPROVED ||
      houkatsuStatus === HoukatsuStatus.APPROVED_FOR_NLP)
  );
};

/**
 * Return true only for Classic consumers (no eKYC or Houkatsu), otherwise false
 * @param kycStatus user eKYC status
 */
export const isClassicUser = (kycStatus?: KYCStatus) => {
  return (
    kycStatus === KYCStatus.NEVER_APPLIED || kycStatus === KYCStatus.REJECTED
  );
};
